// extracted by mini-css-extract-plugin
module.exports = {"header":"progress-header_3z50w","headerCenter":"progress-header_6rCCD","spacer":"progress-header_3OTta","headerHiddenSidebar":"progress-header_3lSAs"};